// Workspace enumeration for guard-web (PRD-001K K3). Pure contract lives in @secops/shared;
// guard-web keeps localStorage persistence and passes stored selection into the resolver.

import {
  ACCOUNT_SELECTION_KEY,
  isStoredSelectionStale,
  resolveEffectiveAccount as resolveEffectiveAccountPure,
  type MyAccount,
} from "../../../../packages/shared/src/account-context.ts";

export { MY_ACCOUNTS_COLUMNS, fetchMyAccounts } from "../../../../packages/shared/src/account-context.ts";
export type { MyAccount } from "../../../../packages/shared/src/account-context.ts";

export function readSelectedAccount(): string | null {
  try {
    return window.localStorage?.getItem(ACCOUNT_SELECTION_KEY) ?? null;
  } catch {
    return null;
  }
}

export function persistSelectedAccount(accountId: string): void {
  try {
    window.localStorage?.setItem(ACCOUNT_SELECTION_KEY, accountId);
  } catch {
    // Selection won't survive reload; config default applies on next boot.
  }
}

export function clearSelectedAccount(): void {
  try {
    window.localStorage?.removeItem(ACCOUNT_SELECTION_KEY);
  } catch {
    // Nothing to clean if storage is unavailable.
  }
}

export function resolveEffectiveAccount(
  configAccountId: string,
  accounts: readonly MyAccount[],
  storedSelection: string | null,
): string {
  if (isStoredSelectionStale(accounts, storedSelection)) {
    clearSelectedAccount();
  }
  return resolveEffectiveAccountPure(configAccountId, accounts, storedSelection);
}
